/**
 * components/accounting/GatewaysManager.tsx
 * Manage dynamic payment gateways: add and remove.
 */

import { useState } from 'react'
import { Trash2, Plus } from 'lucide-react'
import { useUserStore } from '@/store/user'

/**
 * GatewaysManager
 * Lets user add/remove payment gateways. Used by forms/tables.
 */
export function GatewaysManager() {

  const gateways = useUserStore((s) => s.gateways)
  const addGateway = useUserStore((s) => s.addGateway)
  const removeGateway = useUserStore((s) => s.removeGateway)


  const [newGateway, setNewGateway] = useState('')

  const onAdd = () => {
    const name = newGateway.trim()
    if (!name) return
    addGateway(name)
    setNewGateway('')
  }

  const onRemove = (g: string) => {
    const ok = confirm(`حذف البوابة "${g}"؟`)
    if (ok) removeGateway(g)
  }

  return (
    <div>
      <div className="mb-3">
        <label className="mb-1 block text-sm text-slate-600">إضافة بوابة دفع</label>
        <div className="flex gap-2">
          <input
            value={newGateway}
            onChange={(e) => setNewGateway(e.target.value)}
            placeholder="أدخل اسم البوابة"
            className="flex-1 rounded-lg border border-slate-300 bg-white px-3 py-2 text-slate-900 placeholder-slate-400 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100"
          />
          <button
            onClick={onAdd}
            className="inline-flex items-center gap-1 rounded-lg bg-slate-900 px-3 py-2 text-white hover:bg-slate-800"
          >
            <Plus className="h-4 w-4" /> إضافة
          </button>
        </div>
      </div>

      <div>
        <p className="mb-2 text-sm text-slate-600">البوابات الحالية</p>
        <div className="flex flex-wrap gap-2">
          {gateways.length === 0 ? (
            <span className="text-sm text-slate-500">لا توجد بوابات حالياً.</span>
          ) : (
            gateways.map((g) => (
              <span
                key={g.id}
                className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-slate-800"
              >
                {g.name}
                <button
                  onClick={() => onRemove(g.id)}
                  className="rounded-full bg-rose-600 p-1 text-white hover:bg-rose-700"
                  title="حذف"
                >
                  <Trash2 className="h-3 w-3" />
                </button>
              </span>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
